(function () {
  if (window.ZenlartCheckoutDocumentLoaded) return;
  window.ZenlartCheckoutDocumentLoaded = true;

  var attributeName = 'CPF/CNPJ';
  var saving = null;

  function onlyDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function sameDigits(digits) {
    return /^(\d)\1+$/.test(digits);
  }

  function isValidCpf(value) {
    var cpf = onlyDigits(value);
    if (cpf.length !== 11 || sameDigits(cpf)) return false;

    var sum = 0;
    for (var i = 0; i < 9; i += 1) sum += Number(cpf.charAt(i)) * (10 - i);
    var digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    if (digit !== Number(cpf.charAt(9))) return false;

    sum = 0;
    for (var j = 0; j < 10; j += 1) sum += Number(cpf.charAt(j)) * (11 - j);
    digit = 11 - (sum % 11);
    if (digit >= 10) digit = 0;
    return digit === Number(cpf.charAt(10));
  }

  function isValidCnpj(value) {
    var cnpj = onlyDigits(value);
    if (cnpj.length !== 14 || sameDigits(cnpj)) return false;

    var weightsA = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    var weightsB = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    var sum = 0;

    for (var i = 0; i < 12; i += 1) sum += Number(cnpj.charAt(i)) * weightsA[i];
    var digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (digit !== Number(cnpj.charAt(12))) return false;

    sum = 0;
    for (var j = 0; j < 13; j += 1) sum += Number(cnpj.charAt(j)) * weightsB[j];
    digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    return digit === Number(cnpj.charAt(13));
  }

  function isValidDocument(value) {
    var digits = onlyDigits(value);
    return digits.length === 11 ? isValidCpf(digits) : isValidCnpj(digits);
  }

  function formatDocument(value) {
    var digits = onlyDigits(value).slice(0, 14);
    if (digits.length <= 11) {
      return digits
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1-$2');
    }

    return digits
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  function inputs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-zenlart-document-input]'));
  }

  function redirectToCartForDocument() {
    var target = '/cart?document_required=1';
    if (window.location.pathname === '/cart') return false;
    window.location.href = target;
    return true;
  }

  function setInputState(input, valid, touched) {
    var field = input.closest('[data-zenlart-document-field]');
    var error = field ? field.querySelector('[data-zenlart-document-error]') : null;
    input.classList.toggle('zenlart-document-field__input--error', Boolean(touched && !valid));
    input.setAttribute('aria-invalid', touched && !valid ? 'true' : 'false');
    if (error) error.hidden = !(touched && !valid);
  }

  function currentValue() {
    var input = inputs().find(function (item) {
      return onlyDigits(item.value).length > 0;
    });
    return input ? input.value : '';
  }

  function syncInputs(value, touched) {
    var formatted = formatDocument(value);
    inputs().forEach(function (input) {
      if (input.value !== formatted) input.value = formatted;
      setInputState(input, isValidDocument(formatted), touched);
    });
    return formatted;
  }

  function saveDocument(value) {
    var formatted = syncInputs(value, true);
    if (!isValidDocument(formatted)) return Promise.resolve(false);
    if (saving) return saving;

    var body = { attributes: {} };
    body.attributes[attributeName] = formatted;
    body.attributes['Documento do cliente'] = formatted;

    saving = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.ok;
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        saving = null;
      });

    return saving;
  }

  async function validateAndSave(options) {
    if (!inputs().length && redirectToCartForDocument()) return false;

    var value = currentValue();
    var formatted = syncInputs(value, true);
    var valid = isValidDocument(formatted);

    if (!valid) {
      if (options && options.focus) {
        var first = inputs()[0];
        if (first) first.focus();
      }
      return false;
    }

    return saveDocument(formatted);
  }

  function installYampiWrapper(name) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (typeof window[name] !== 'function') {
        if (attempts > 60) window.clearInterval(timer);
        return;
      }

      if (window[name].zenlartDocumentWrapped) {
        window.clearInterval(timer);
        return;
      }

      var original = window[name];
      window[name] = async function () {
        var ok = await validateAndSave({ focus: true });
        if (!ok) return false;
        return original.apply(this, arguments);
      };
      window[name].zenlartDocumentWrapped = true;
      window.clearInterval(timer);
    }, 250);
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-zenlart-document-input]')) return;
    var formatted = syncInputs(event.target.value, false);
    event.target.value = formatted;
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-zenlart-document-input]')) return;
    saveDocument(event.target.value);
  });

  document.addEventListener('click', function (event) {
    var target = event.target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout, a[href="/checkout"], a[href="/a/checkout"], .btn-checkout, .yampi_purchase_confirmation_btn');
    if (!target) return;

    if (!isValidDocument(currentValue())) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!inputs().length && redirectToCartForDocument()) return;
      validateAndSave({ focus: true });
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action="/cart"], form[action$="/cart"]')) return;
    if (!isValidDocument(currentValue())) {
      event.preventDefault();
      validateAndSave({ focus: true });
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var requireDocument = new URLSearchParams(window.location.search).has('document_required');
    syncInputs(currentValue(), requireDocument);
    if (requireDocument && inputs()[0]) inputs()[0].focus();
    installYampiWrapper('yampiClick');
    installYampiWrapper('getNewCheckoutURL');
  });
})();
